export default {
    async fetchSiteData({commit, dispatch, state, getters}, {
        siteId,
        loadResourceBookingsOnly: loadResourceBookingsOnly = false
    }) {

        const {$axios, $apiRoute} = useNuxtApp()

        try {
            if (!loadResourceBookingsOnly) {
                commit('setSiteIsLoaded', false)
                let responseData = (await $axios.get($apiRoute('api.bookings.sites.show', {site: siteId}), {
                    params: {
                        preview: state.previewMode
                    }
                })).data
                commit('setSiteData', responseData.siteData)
                commit('setFormSelectChoices', responseData.formSelectChoices)
                if (responseData?.siteData?.internal)
                    await dispatch('getAuthData')
            } else {
                let siteData = (await $axios.get($apiRoute('api.bookings.sites.show', {site: siteId}),
                    {
                        params: {
                            loadResourceBookingsOnly: true
                        },
                        progress: false
                    }
                )).data
                commit('setSiteData', siteData)
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    showError({statusCode: 403, message: "not_found"})
                } else if (error.response.status === 403) {
                    showError({statusCode: 403, message: error.response.data?.message, data: error.response.data})
                } else if (error.response.status === 500) {
                    showError({statusCode: 500})
                }
            } else {
                console.log(error)
            }
        }

        commit('setSiteIsLoaded', true)
    },

    async sendBooking({commit, state}) {
        const {$axios, $apiRoute} = useNuxtApp()
        try {
            commit('setSiteIsLoaded', false)
            const response = await $axios.post($apiRoute('api.bookings.sites.bookings.store', {site: state.siteData.id}),
                state.bookingData
            )
            commit('setBookingProp', {prop: "id", value: response.data.id})
            commit('setBookingProp', {prop: "token", value: response.data.token})
            commit('setBookingFinishedSuccessful', true)
            commit('setSiteIsLoaded', true)
        } catch (e) {
            commit('setSiteIsLoaded', true)
            this.$notify({type: 'danger', message: this.$i18n.t('error.errorWhileRegistraton'), timeout: 15000})
            console.log(e)
            console.log(e.response.data)
        }
    },


    login(_, {loginData}) {
        const {$axios, $apiRoute} = useNuxtApp()
        return new Promise(async (resolve, reject) => {
            try {
                let response = (await $axios.post($apiRoute('spa.login'), {...loginData}))
                resolve(response)
            } catch (e) {
                this.$notify({type: 'warning', message: this.$i18n.t('auth.wrongCredentials')})
                reject(e)
            }
        })
    },

    async successfulLogin({dispatch, commit}) {
        return new Promise(async (resolve, reject) => {
            try {
                commit('setAuthenticated', true)
                await dispatch('getAuthData')
                resolve(true)
            } catch (error) {
                reject(error)
            }
        })
    },

    async getAuthData({dispatch}) {
        const {$axios, $apiRoute} = useNuxtApp()
        try {
            let response = await $axios.get($apiRoute('spa.authData'))
            await dispatch('setAuthData', response.data)
        } catch (error) {
            throw(error)
        }
    },

    setAuthData({commit}, authData) {
        commit('setAuthenticated', true)
        commit('setAbilities', authData.abilities)
        commit('setUserData', authData.userData)

        if (authData.userData?.kontaktId)
            commit('setBookingProp', {prop: "contactId", value: authData.userData.kontaktId, path: "booker"})
        if (authData.userData?.contact) {
            commit('setBookingProp', {prop: "firstname", value: authData.userData.contact.firstName, path: "booker"})
            commit('setBookingProp', {prop: "lastname", value: authData.userData.contact.lastName, path: "booker"})
            commit('setBookingProp', {prop: "salutation", value: authData.userData.contact.salutation, path: "booker"})
        }
    }
}